import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHelper from '../../../util/ReactHelper';
import GoogleMapReact from 'google-map-react'; // { Map, GoogleApiWrapper, Marker }

// https://dev.to/jessicabetts/how-to-use-google-maps-api-and-react-js-26c2

const mapStyles = {
    width: '100%',
    height: '100%',
};

class MapContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            map: null,
        }

        this.mapRef = React.createRef()
        this.otherMarkers = {}
        this.infoWindow = null
    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    getCenter = () => {
        let map = this.state.map
        return map.center
    }

    componentDidUpdate(prevProps, prevState) {
        this.renderMarkers()
    }
    handleApiLoaded = (map, maps) => {
        this.createMarkerOverlay(map)
        this.initializeGeocoder()
        this.setState({map})
        this.props.mapReady()
    }

    createMarkerOverlay = (map) => {
        var myoverlay = new google.maps.OverlayView();
        myoverlay.draw = function () {
            this.getPanes().markerLayer.id='markerLayer';
        };
        myoverlay.setMap(map);
    }

    setDestinationIconImage = ({url, size, label}) => {
        if (this.infoWindow) {
            this.infoWindow.close()
            this.infoWindow = null
        }
        if (label) {
            this.infoWindow = new google.maps.InfoWindow({
                content: label
            })
        }
        if (this.state.destinationMarker) {
            this.state.destinationMarker.setIcon({
                url: url,
                label: label,
                scaledSize: size && new google.maps.Size(size[0], size[1]),
            })
            if (this.infoWindow) {
                this.infoWindow.open(this.state.map, this.state.destinationMarker)
                setTimeout(() => {
                    $('.gm-style-iw.gm-style-iw-c').find('button.gm-ui-hover-effect').css('display', 'none')
                }, 100)
            }
        }
    }

    // For parent to trigger destination position change
    setDestinationPosition = (position, isSkipGeocode) => {
        if (this.state.destinationMarker) {
            this.state.destinationMarker.setPosition(position)
            if (!isSkipGeocode) {
                this.destinationMarkerDragend()
            }
        }
    }

    getDestinationCoordinate = () => {
        return this.state.destinationMarker && this.state.destinationMarker.position.toJSON()
    }
    destinationMarkerDragend = (e) => {
        if (this.state.destinationMarker.position) {
            let latLng = this.state.destinationMarker.position.toJSON()
            this.geocodeLatLng(latLng.lat, latLng.lng)
        }
    }
    zoomToDestination = () => {
        const map = this.state.map
        if (!this.state.destinationMarker || !map) { return }

        map.setZoom(17);
        map.panTo(this.state.destinationMarker.position);
    }

    initializeGeocoder() {
        this.geocoder = new google.maps.Geocoder();
    }

    codeAddress(address) {
        geocoder.geocode( { 'address': address}, function(results, status) {
          if (status == 'OK') {
            map.setCenter(results[0].geometry.location);
            var marker = new google.maps.Marker({
                map: map,
                position: results[0].geometry.location
            });
          } else {
            alert('Geocode was not successful for the following reason: ' + status);
          }
        });
      }
    geocodeLatLng(lat,lng) {
        var latlng = {lat: lat, lng: lng};
        this.geocoder.geocode({'location': latlng}, (results, status) => {
            if (status === 'OK') {
                if (results[0]) {
                    this.props.geocodeResult && this.props.geocodeResult(results, 'marker')
                } else {
                    window.alert('No results found');
                }
            } else {
                window.alert('Geocoder failed due to: ' + status);
            }
        });
    }
    renderMarkers = () => {
        const map = this.state.map
        if (!map) {
            return
        }
        if (this.props.otherMarkers) {
            (this.props.otherMarkers || []).forEach(otherMarker => {
                if (!this.otherMarkers[otherMarker.id]) {
                    this.otherMarkers[otherMarker.id] = new google.maps.Marker({
                        position: otherMarker.position,
                        map: map,
                        draggable: false,
                        optimized: true,
                    })
                }
                else {
                    this.otherMarkers[otherMarker.id].setPosition(otherMarker.position)
                }
            })
        }
        let destinationMarker = this.state.destinationMarker
        let newDestination = this.props.destinationMarker
        if (newDestination) {
            if (!destinationMarker) {
                let icon = newDestination.icon
                destinationMarker = new google.maps.Marker({
                    position: newDestination.position,
                    map: map,
                    draggable: typeof newDestination.draggable === 'undefined' ? true : newDestination.draggable,
                    icon: icon && {
                        url: icon.url,
                        scaledSize: icon.size && new google.maps.Size(icon.size[0], icon.size[1]),
                    },
                    optimized: !!icon,
                })
                this.destinationMarkerDragendListener = destinationMarker.addListener('dragend', this.destinationMarkerDragend)
                this.setState({destinationMarker}, () => {
                    // Trigger geocoding to get address
                    newDestination.position && this.destinationMarkerDragend()
                })

                // First time add destination fitBounds if needed
                if (this.props.fitBounds && this.props.otherMarkers.length > 0) {
                    var bounds = new google.maps.LatLngBounds();
                    bounds.extend(new google.maps.LatLng(newDestination.position.lat, newDestination.position.lng))
                    this.props.otherMarkers.forEach(otherMarker => {
                        bounds.extend(new google.maps.LatLng(otherMarker.position.lat, otherMarker.position.lng));
                    })
                    // Without this small delay, fitBounds will set zoom to 0 on second time
                    // loading of the map
                    setTimeout(() => map.fitBounds(bounds), 200)
                }
            }
        }
        else if (!this.props.destinationMarker && destinationMarker) {
            // Remove from map
            destinationMarker.setMap(null)
        }
    }

    render() {
        let center = this.props.initialCenter || { lat: 3.120123, lng: 101.678017 }
        return (
            <div style={{width: "100%", height: "100%"}}>
                <GoogleMapReact
                    bootstrapURLKeys={{ key: window.GOOGLE_MAP_API_KEY }}
                    defaultCenter={center}
                    defaultZoom={13}
                    options={{
                        fullscreenControl: false
                    }}
                    yesIWantToUseGoogleMapApiInternals
                    onGoogleApiLoaded={({map, maps}) => this.handleApiLoaded(map, maps)} >
                </GoogleMapReact>
            </div>
        );
    }
}
MapContainer.defaultProps = {
    otherMarkers: []
}
MapContainer.propTypes = {

};
export default MapContainer;